module.exports = __webpack_public_path__ + "resources/img/guide-bg1.ffbe2620.png";